import type { ReactNode } from 'react';
import { nfmt } from '../lib/format';
import { CoinIcon, CrystalIcon } from './Currency';
import { haptic } from '../lib/telegram';

/** Шапка сквозная. Спин-билеты сюда не выносим — они живут только на колесе. */
export function Header({ title, coins, crystals, onCoins, onCrystals }: {
  title: string; coins: number; crystals: number;
  onCoins: () => void; onCrystals: () => void;
}) {
  return (
    <header className="sticky top-0 z-20 -mx-4 mb-4 px-4 pb-3 pt-[max(12px,env(safe-area-inset-top))]
                       backdrop-blur-xl [background:linear-gradient(var(--ink)_60%,transparent)]">
      <div className="flex items-center justify-between gap-3">
        <h1 className="font-display text-[17px] font-semibold tracking-tight">{title}</h1>
        <div className="flex items-center gap-2">
          <Pill onClick={() => { haptic.tap(); onCoins(); }} tone="gold" value={coins} icon={<CoinIcon size={15} />} />
          <Pill onClick={() => { haptic.tap(); onCrystals(); }} tone="violet" value={crystals} icon={<CrystalIcon size={15} />} />
        </div>
      </div>
    </header>
  );
}

function Pill({ tone, value, icon, onClick }: {
  tone: 'gold' | 'violet'; value: number; icon: ReactNode; onClick: () => void;
}) {
  const ring = tone === 'gold'
    ? 'border-gold/35 bg-gold/10 text-gold'
    : 'border-violet/35 bg-violet/10 text-violet';
  return (
    <button onClick={onClick}
      className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1.5 text-[13px] font-bold num ${ring}
                  transition active:scale-95`}>
      {icon}{nfmt(value)}
    </button>
  );
}
